import * as _viewerShared2 from "@shapediver/viewer.shared.types";
var _viewerShared = _viewerShared2;
try {
  if ("default" in _viewerShared2) _viewerShared = _viewerShared2.default;
} catch (e) {}
import * as _viewerShared4 from "@shapediver/viewer.shared.services";
var _viewerShared3 = _viewerShared4;
try {
  if ("default" in _viewerShared4) _viewerShared3 = _viewerShared4.default;
} catch (e) {}
import * as _viewerDataEngine2 from "@shapediver/viewer.data-engine.geometry-engine";
var _viewerDataEngine = _viewerDataEngine2;
try {
  if ("default" in _viewerDataEngine2) _viewerDataEngine = _viewerDataEngine2.default;
} catch (e) {}
import * as _viewerDataEngine4 from "@shapediver/viewer.data-engine.html-element-anchor-engine";
var _viewerDataEngine3 = _viewerDataEngine4;
try {
  if ("default" in _viewerDataEngine4) _viewerDataEngine3 = _viewerDataEngine4.default;
} catch (e) {}
import * as _viewerShared6 from "@shapediver/viewer.shared.node-tree";
var _viewerShared5 = _viewerShared6;
try {
  if ("default" in _viewerShared6) _viewerShared5 = _viewerShared6.default;
} catch (e) {}
import * as _glMatrix2 from "gl-matrix";
var _glMatrix = _glMatrix2;
try {
  if ("default" in _glMatrix2) _glMatrix = _glMatrix2.default;
} catch (e) {}
import * as _viewerDataEngine6 from "@shapediver/viewer.data-engine.material-engine";
var _viewerDataEngine5 = _viewerDataEngine6;
try {
  if ("default" in _viewerDataEngine6) _viewerDataEngine5 = _viewerDataEngine6.default;
} catch (e) {}
import * as _viewerDataEngine8 from "@shapediver/viewer.data-engine.sdtf-engine";
var _viewerDataEngine7 = _viewerDataEngine8;
try {
  if ("default" in _viewerDataEngine8) _viewerDataEngine7 = _viewerDataEngine8.default;
} catch (e) {}
import * as _viewerDataEngine10 from "@shapediver/viewer.data-engine.tag3d-engine";
var _viewerDataEngine9 = _viewerDataEngine10;
try {
  if ("default" in _viewerDataEngine10) _viewerDataEngine9 = _viewerDataEngine10.default;
} catch (e) {}
var exports = {};
var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataEngine = void 0;
const viewer_shared_types_1 = _viewerShared;
const viewer_shared_services_1 = _viewerShared3;
const viewer_data_engine_geometry_engine_1 = _viewerDataEngine;
const viewer_data_engine_html_element_anchor_engine_1 = _viewerDataEngine3;
const viewer_shared_node_tree_1 = _viewerShared5;
const gl_matrix_1 = _glMatrix;
const viewer_data_engine_material_engine_1 = _viewerDataEngine5;
const viewer_data_engine_sdtf_engine_1 = _viewerDataEngine7;
const viewer_data_engine_tag3d_engine_1 = _viewerDataEngine9;
class DataEngine {
  constructor() {
    // #region Properties (8)
    this._eventEngine = viewer_shared_services_1.EventEngine.instance;
    this._geometryEngine = viewer_data_engine_geometry_engine_1.GeometryEngine.instance;
    this._htmlElementAnchorEngine = viewer_data_engine_html_element_anchor_engine_1.HTMLElementAnchorEngine.instance;
    this._materialEngine = viewer_data_engine_material_engine_1.MaterialEngine.instance;
    this._sdtfEngine = viewer_data_engine_sdtf_engine_1.SDTFEngine.instance;
    this._tag3dEngine = viewer_data_engine_tag3d_engine_1.Tag3dEngine.instance;
    this._uuidGenerator = viewer_shared_services_1.UuidGenerator.instance;
    // #endregion Public Methods (1)
  }
  // #endregion Properties (8)
  // #region Public Static Getters And Setters (1)
  static get instance() {
    return this._instance || (this._instance = new this());
  }
  // #endregion Public Static Getters And Setters (1)
  // #region Public Methods (1)
  loadContent(content, jwtToken, taskEventId) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!content || content && !content.format) throw new viewer_shared_services_1.ShapeDiverViewerDataProcessingError("DataEngine cannot load content.");
      taskEventId = taskEventId || this._uuidGenerator.create();
      let node;
      if (content.format === "glb" || content.format === "gltf") {
        node = yield this._geometryEngine.loadContent(content, taskEventId);
      } else if (content.format === "material") {
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, {
          type: viewer_shared_types_1.TASK_TYPE.MATERIAL_CONTENT_LOADING,
          id: taskEventId,
          progress: 0,
          status: "Loading material content."
        });
        node = yield this._materialEngine.loadContent(content);
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, {
          type: viewer_shared_types_1.TASK_TYPE.MATERIAL_CONTENT_LOADING,
          id: taskEventId,
          progress: 1,
          status: "MATERIAL content loaded."
        });
      } else if (content.format === "tag2d" || content.format === "anchor") {
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, {
          type: viewer_shared_types_1.TASK_TYPE.TAG_CONTENT_LOADING,
          id: taskEventId,
          progress: 0,
          status: "Loading tag content."
        });
        node = yield this._htmlElementAnchorEngine.loadContent(content);
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, {
          type: viewer_shared_types_1.TASK_TYPE.TAG_CONTENT_LOADING,
          id: taskEventId,
          progress: 1,
          status: "Tag content loaded."
        });
      } else if (content.format === "tag3d") {
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, {
          type: viewer_shared_types_1.TASK_TYPE.TAG_CONTENT_LOADING,
          id: taskEventId,
          progress: 0,
          status: "Loading tag content."
        });
        node = yield this._tag3dEngine.loadContent(content);
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, {
          type: viewer_shared_types_1.TASK_TYPE.TAG_CONTENT_LOADING,
          id: taskEventId,
          progress: 1,
          status: "Tag content loaded."
        });
      } else if (content.format === "sdtf") {
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, {
          type: viewer_shared_types_1.TASK_TYPE.SDTF_CONTENT_LOADING,
          id: taskEventId,
          progress: 0,
          status: "Loading sdTF content."
        });
        node = yield this._sdtfEngine.loadContent(content, jwtToken);
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, {
          type: viewer_shared_types_1.TASK_TYPE.SDTF_CONTENT_LOADING,
          id: taskEventId,
          progress: 1,
          status: "SdTF content loaded."
        });
      } else {
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, {
          type: viewer_shared_types_1.TASK_TYPE.CUSTOM_CONTENT_LOADING,
          id: taskEventId,
          progress: 0,
          status: "Loading custom content."
        });
        node = new viewer_shared_node_tree_1.TreeNode("custom");
        node.data.push(new viewer_shared_types_1.CustomData(Object.assign({}, content)));
        this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, {
          type: viewer_shared_types_1.TASK_TYPE.CUSTOM_CONTENT_LOADING,
          id: taskEventId,
          progress: 1,
          status: "Custom content loaded."
        });
      }
      const transformationNode = new viewer_shared_node_tree_1.TreeNode("transformation");
      if (content.transformations && Array.isArray(content.transformations)) {
        for (let i = 0; i < content.transformations.length; i++) {
          const t = content.transformations[i];
          if (Array.isArray(t) && t.length === 16) {
            const nodeInstance = node.clone();
            nodeInstance.transformations = [{
              id: "content_" + i,
              matrix: gl_matrix_1.mat4.fromValues(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15])
            }].concat(node.transformations);
            transformationNode.updateVersion();
            transformationNode.addChild(nodeInstance);
          }
        }
      } else {
        transformationNode.addChild(node);
      }
      return transformationNode;
    });
  }
}
exports.DataEngine = DataEngine;
//# sourceMappingURL=DataEngine.js.map
export default exports;